import { motion } from "framer-motion";

export const easeOut = [0.22, 1, 0.36, 1];

// Staggered word-by-word reveal with a masked slide-up
export const AnimatedWords = ({ text, className = "", delay = 0, once = true, immediate = false }) => {
  const words = text.split(" ");
  const container = {
    hidden: {},
    visible: {
      transition: { staggerChildren: 0.045, delayChildren: delay },
    },
  };
  const child = {
    hidden: { y: "110%" },
    visible: { y: "0%", transition: { duration: 0.4, ease: easeOut } },
  };
  const trigger = immediate
    ? { animate: "visible" }
    : { whileInView: "visible", viewport: { once, amount: 0.5 } };
  return (
    <motion.span
      className={className}
      variants={container}
      initial="hidden"
      {...trigger}
      aria-label={text}
    >
      {words.map((word, i) => (
        <span
          key={i}
          className="inline-block overflow-hidden align-bottom"
          style={{ paddingBottom: "0.08em" }}
        >
          <motion.span variants={child} className="inline-block pr-[0.25em]">
            {word}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};

// Simple fade + rise reveal
export const Reveal = ({ children, className = "", delay = 0, y = 40, once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, amount: 0.3 }}
    transition={{ duration: 0.8, ease: easeOut, delay }}
  >
    {children}
  </motion.div>
);
